<template>
  <!-- 打印检品单 -->
  <div>
    <div class="main" id="print" ref="print">
      <div class="content">
        <div class="title">{{ datas.typeName }}检品单</div>
        <div class="footer">
          <div class="text">
            <p>配货组：{{ datas.p_admin ? datas.p_admin.role[0].organization.name : '' }}</p>
            <p>配货员：{{ datas.p_admin ? datas.p_admin.realname : '' }}</p>
            <p>{{ datas.typeName }}员：{{ datas.j_admin ? datas.j_admin.realname : '' }}</p>
            <p>缝标员：{{ datas.label_admin ? datas.label_admin.realname : '' }}</p>
            <div class="user_attribute">
              <span :class="{ svip: datas.user_attribute == 'SVIP', vip: datas.user_attribute == '付费会员' }"> {{
                datas.user_attribute }}</span>

            </div>
          </div>
          <div class="tiaoxingma">
            <div class="item">
              <div class="item-top">{{ datas.typeName }}检品单号：{{ datas.inspect_sn }}</div>
              <!-- 二维码 -->
              <div class="item-footer">
                <canvas id="inspect_sn" />
              </div>
            </div>

            <div class="dayintime">
              打印时间：
              <p>
                {{ transferDate(new Date()) }}
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { transferDate } from '../../utlis/date'
export default {
  props: {
    datas: { type: Object }
  },
  data() {
    return {
      transferDate
    }
  },
  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },
  mounted() {
    console.log(this.datas);
    this.getJsBarcode("#inspect_sn", this.datas.inspect_sn);
  },
  methods: {
    print() {
      this.$print(this.$refs.print)
    },
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {

        height: 240,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
  }

  .content {
    width: 1061px;
    height: 1652px;

    border: 8px solid #000000;
    border-top: 0;
    position: relative;
    padding-top: 160px;

    .title {
      position: absolute;
      left: -8px;
      top: 0;
      width: 1061px;
      height: 160px;
      background: #000000;
      text-align: center;
      line-height: 160px;
      font-size: 80px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #ffffff;
      margin: 0;
    }

    .footer {
      width: 100%;
      height: 1492px;
      padding: 60px 60px 50px 60px;
      box-sizing: border-box;

      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 300px;
        padding: 10px 0;
        margin-bottom: 60px;
        position: relative;

        p {
          font-size: 40px;
          font-family: PingFang SC;
          height: 60px;
          line-height: 60px;
          font-weight: 600;
          color: #000000;
        }

        .user_attribute {
          position: absolute;
          top: 50%;
          right: 50px;
          transform: translate(0, -50%);

          span {
            font-size: 50px;
            font-weight: bold;
          }

          .svip {
            font-size: 150px;

          }

          .vip {
            font-size: 120px;

          }
        }
      }

      .tiaoxingma {
        .item {
          width: 100%;
          height: 320px;
          margin-bottom: 280px;
          box-sizing: border-box;

          .item-top {
            width: 100%;
            height: 60px;
            line-height: 60px;
            font-size: 40px;

            font-weight: 600;
            color: #000000;
            margin-bottom: 20px;
            box-sizing: border-box;
          }

          .item-footer {
            width: 100%;
            height: 240px;

            img {
              width: 100%;
              height: 240px;
              background-color: pink;
            }
          }
        }

        .dayintime {
          width: 100%;
          // height: 642px;
          font-size: 50px;
          // padding-top: 600px;

          font-weight: 400;
          // font-weight: bold;
          // background-color: pink;
          color: #000000;

          p {
            font-size: 180px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
